interface UserIconStaticProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const UserIconStatic = ({
  width = 16,
  height = 16,
  className,
  color = "currentColor",
  strokeWidth = 1.5
}: UserIconStaticProps) => {
  // Head circle path
  const headPath =
    "M8 1.75C9.79439 1.75 11.249 3.20464 11.249 4.99902C11.249 6.79341 9.79439 8.24805 8 8.24805C6.20561 8.24805 4.75098 6.79341 4.75098 4.99902C4.75098 3.20464 6.20561 1.75 8 1.75Z";

  // Body path
  const bodyPath =
    "M14.25 14.25V11.4111C14.25 10.7717 13.9861 10.2226 13.543 9.91406L13.4512 9.85547C12.2794 9.1634 10.3083 8.26562 8 8.26562C5.97997 8.26564 4.21825 8.95334 3.02441 9.58887L2.54883 9.85547C2.05078 10.1496 1.75 10.7289 1.75 11.4111V14.25H14.25Z";

  return (
    <div className={className} style={{ width, height }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={headPath}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
        />

        <path
          d={bodyPath}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
        />
      </svg>
    </div>
  );
};
